<template>
  <div class="login-page">
    <div v-if="isLoading == false" class="login-wrap">
      <v-card class="login-card" elevation="0">
        <!-- Médaillon -->
        <div class="login-badge">
          <v-icon size="34" color="white">mdi-lock-outline</v-icon>
        </div>

        <h1 class="login-title">Connexion</h1>
        <div class="login-subtitle">ACCEN — Web applications</div>

        <v-text-field
          class="login-field"
          v-model="user.email"
          label="Utilisateur"
          type="text"
          variant="outlined"
          density="comfortable"
          rounded="lg"
          hide-details
          prepend-inner-icon="mdi-account-outline"
          @keyup.enter="login"
        ></v-text-field>

        <v-text-field
          class="login-field"
          v-model="user.password"
          label="Mot de passe"
          :type="showPassword ? 'text' : 'password'"
          variant="outlined"
          density="comfortable"
          rounded="lg"
          hide-details
          prepend-inner-icon="mdi-lock-outline"
          :append-inner-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
          @click:append-inner="showPassword = !showPassword"
          @keyup.enter="login"
        ></v-text-field>

        <div v-if="invalidUser" class="login-error">
          <v-icon size="18" class="mr-2">mdi-alert-circle-outline</v-icon>
          L'adresse email ou le mot de passe est incorrect
        </div>

        <v-btn
          class="login-btn"
          block
          size="large"
          rounded="lg"
          :loading="submitting"
          @click="login"
        >
          <v-icon start>mdi-login-variant</v-icon>
          Se connecter
        </v-btn>
      </v-card>

      <div class="login-foot">© ACCEN — Web applications</div>
    </div>

    <div v-else class="login-loading">
      <v-progress-circular size="110" indeterminate color="#3F51B5"></v-progress-circular>
    </div>
  </div>
</template>

<script>
import engine from "@/core/index";

export default {
  data() {
    return {
      isLoading: true,
      invalidUser: false,
      showPassword: false,
      submitting: false,
      user: { email: "", password: "" },
      items: [
        {
          text: "Planning Disponibilité",
          href: "planning-disponibilite",
          disabled: false,
        },
        {
          text: "Planning Livraison",
          href: "planning-livraison",
          disabled: false,
        },
        {
          text: "Planning Opérateurs",
          href: "planning-operateur",
          disabled: false,
        },
        {
          text: "Statistiques",
          href: "statistiques",
          disabled: false,
        },
      ],
    };
  },
  mounted() {
    this.isUserConnected();
  },
  methods: {
    updateUser() {
      let that = this;
      let token = localStorage.getItem("userToken");
      engine.get_user_by_token(token, function (data) {
        if (data.code == 0) {
          let user = data.data.data.data[0].fieldData;
          delete user.user_id;
          delete user.user_password;
          that.$store.state.user = user;
        } else {
          that.$router.push("/login");
        }
        that.isLoading = false;
      });
    },
    isUserConnected() {
      let that = this;
      let token = localStorage.getItem("userToken");
      engine.get_user_by_token(token, function (data) {
        if (data.code == 0) {
          that.goToCalendarPage();
        } else {

          localStorage.setItem("userToken", undefined);
          that.isLoading = false;
        }
      });
    },
    login() {
      let that = this;
      if (this.user.email.length !== 0 && this.user.password.length !== 0) {
        that.invalidUser = false;
        that.submitting = true;
        engine.user_login(this.user.email, this.user.password, function (data) {
          that.$store.replaceState({});
          if (data.code == 0) {
            localStorage.setItem("userToken", data.data.id);
            that.updateUser();
            that.goToCalendarPage();
          } else {
            that.invalidUser = true;
            that.submitting = false;
          }
        });
      } else that.invalidUser = true;
    },
    goToCalendarPage() {
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
.login-page {
  min-height: 92vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 24px 16px;
  background:
    radial-gradient(900px 380px at 50% -6%, rgba(63, 81, 181, .18), transparent 70%),
    radial-gradient(700px 300px at 100% 110%, rgba(63, 81, 181, .10), transparent 70%);
}

.login-wrap {
  width: 100%;
  max-width: 430px;
  margin-top: 12vh;
}

.login-card {
  position: relative;
  padding: 46px 30px 26px;
  border-radius: 20px !important;
  background: #ffffff;
  border: 1px solid #e8eaf6;
  box-shadow: 0 20px 48px rgba(40, 47, 100, .16) !important;
  text-align: center;
  overflow: visible;
}

.login-badge {
  position: absolute;
  top: -32px;
  left: 50%;
  transform: translateX(-50%);
  width: 64px;
  height: 64px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(150deg, #5C6BC0 0%, #3949AB 100%);
  box-shadow: 0 10px 24px rgba(57, 73, 171, .4);
}

.login-title {
  margin: 6px 0 2px;
  font-size: 24px;
  font-weight: 800;
  letter-spacing: -.01em;
  color: #1a2138;
}

.login-subtitle {
  font-size: 13.5px;
  color: #7986CB;
  margin-bottom: 24px;
}

.login-field {
  text-align: left;
  margin-bottom: 14px;
}

.login-error {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;
  background: #fdecee;
  color: #c62828;
  font-weight: 600;
  font-size: 13px;
  border: 1px solid #f7c6cc;
  border-radius: 10px;
  padding: 9px 12px;
  margin-bottom: 14px;
}

.login-btn {
  background: linear-gradient(150deg, #3F51B5 0%, #303F9F 100%) !important;
  color: #ffffff !important;
  font-weight: 700;
  letter-spacing: .02em;
  text-transform: none;
  box-shadow: 0 10px 22px rgba(63, 81, 181, .32) !important;
  transition: transform .12s ease, filter .12s ease, box-shadow .12s ease;
}

.login-btn:hover {
  transform: translateY(-1px);
  filter: brightness(1.05);
  box-shadow: 0 12px 26px rgba(63, 81, 181, .42) !important;
}

.login-foot {
  text-align: center;
  margin-top: 16px;
  font-size: 12px;
  color: #9fa8da;
}

.login-loading {
  margin-top: 38vh;
  text-align: center;
}
</style>
